import {
  Badge,
  Card,
  Image,
  SimpleGrid,
  Stack,
  Text,
  Title,
} from "@mantine/core";

import { GuestInfoBite } from "./GuestInfoBite";

interface InfoCardGridProps {
  informations: GuestInfoBite[];
  handleOpen: (slug: string) => void;
  previousActiveInfo: number;
}

const InfoCardGrid = ({
  informations,
  handleOpen,
  previousActiveInfo,
}: InfoCardGridProps) => {
  return (
    <SimpleGrid
      cols={{ base: 1, xs: 2, md: 3, lg: 4 }}
      spacing="lg"
      verticalSpacing="lg"
    >
      {informations.map((info, index) => (
        <Card
          key={info._slug}
          padding="md"
          withBorder
          onClick={() => handleOpen(info._slug)}
          style={{
            cursor: "pointer",
            transition:
              "transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease",
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
          onMouseEnter={(event) => {
            event.currentTarget.style.transform = "translateY(-3px)";
            event.currentTarget.style.boxShadow = "var(--mantine-shadow-md)";
          }}
          onMouseLeave={(event) => {
            event.currentTarget.style.transform = "translateY(0)";
            event.currentTarget.style.boxShadow = "";
          }}
        >
          <Card.Section>
            <Image
              src={`/img/infos/${info._slug}.jpg`}
              h={140}
              alt={info.title}
              fallbackSrc="/img/pool-day.jpg"
              fit="cover"
            />
          </Card.Section>
          <Stack gap={6} mt="md" style={{ flex: 1 }}>
            <Title order={4} lh={1.2}>
              {info.title}
            </Title>
            <Text size="sm" c="dimmed" lineClamp={3}>
              {info.instruction}
            </Text>
            {index === previousActiveInfo && (
              <Badge
                color="blossom"
                variant="light"
                radius="sm"
                mt={4}
                w="fit-content"
              >
                Just seen
              </Badge>
            )}
          </Stack>
        </Card>
      ))}
    </SimpleGrid>
  );
};

export default InfoCardGrid;
